var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFloppyDiskBack = function SvgIconFloppyDiskBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.375 13.875a3.625 3.625 0 1 1 7.25 0 3.625 3.625 0 0 1-7.25 0M12 12.25a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.895 2.88a1.7 1.7 0 0 1 .666-.13h.002l-.004 1v-1H19.5a1.75 1.75 0 0 1 1.75 1.75v15a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75V8.56v.003l1-.004h-1v.002M8.664 4.75 4.75 8.664V19.25h14.5V4.75H16V7.5a1 1 0 0 1-1 1H9.75a1 1 0 1 1 0-2H14V4.75z"
  }))));
};
export default SvgIconFloppyDiskBack;